export const getSquadCases = (userIdList, limit) => `
SELECT
    Id,
    CaseNumber,
    CreatedDate,
    Imagem_Status__c,
    Status,
    Subject,
    Owner.Name,
    OwnerId
FROM
    Case
WHERE
    OwnerId IN (${userIdList.map(userId => `'${userId}'`).join(', ')})
    AND Status NOT IN ('Resolvido', 'Fechado', 'Closed as Duplicate', 'Closed', 'Merged')
ORDER BY 
    CreatedDate DESC
    ${limit ? `LIMIT ${limit}` : ''}
`;
